// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2mLwF","upload":"Small_upload__3raES","imageWrap":"Small_imageWrap__1F7fo","removeBtn":"Small_removeBtn__pwAeO"};